export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SideBar.vue?vue&type=template&id=25294b0d&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarPlugin/SideBar.vue?vue&type=template&id=25294b0d&scoped=true
// module id = 1455
// module chunks = 31